import React from 'react';
import {usePost} from '../../data/resources';
import {usePageMeta} from '../../seo/usePageMeta';

interface WordPressPageProps {
    postId: number;
    title: string;
    description: string;
}

/** A page whose content is maintained as a WordPress post (Impressum, Halle, …). */
const WordPressPage = ({postId, title, description}: WordPressPageProps) => {
    usePageMeta({title, description});
    const {data: post, error} = usePost(postId);

    return (
        <div className="page page--narrow">
            <article className="card content-card">
                {post ? (
                    <>
                        <h1 className="content-title">{post.title}</h1>
                        <div className="prose" dangerouslySetInnerHTML={{__html: post.content ?? ''}}/>
                    </>
                ) : error ? (
                    <p className="empty-state">Der Inhalt konnte nicht geladen werden.</p>
                ) : (
                    <div aria-hidden="true">
                        {Array.from({length: 6}, (_, i) => <div key={i} className="skeleton skeleton-line"/>)}
                    </div>
                )}
            </article>
        </div>
    );
};

export default WordPressPage;
